module.exports = __webpack_public_path__ + "img/relatorio.5f1f2c89.svg";